import React from 'react';
import { Paper, List, ListItemButton, ListItemText, Typography, Box } from '@mui/material';
import schoolEvents from '../../data/school-events.json';

interface EventCategoriesProps {
  selectedCategory: string;
  onCategorySelect: (categoryId: string) => void;
}

export const EventCategories: React.FC<EventCategoriesProps> = ({
  selectedCategory,
  onCategorySelect
}) => {
  return (
    <Paper 
      sx={{ 
        height: '100%',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        '&::-webkit-scrollbar': {
          width: 8
        },
        '&::-webkit-scrollbar-track': {
          bgcolor: 'background.default',
          borderRadius: 4
        },
        '&::-webkit-scrollbar-thumb': {
          bgcolor: 'primary.light',
          borderRadius: 4,
          '&:hover': {
            bgcolor: 'primary.main'
          }
        }
      }}
    >
      <List component="nav" sx={{ py: 0 }}>
        {schoolEvents.categories.map((category) => (
          <ListItemButton
            key={category.id}
            selected={selectedCategory === category.id}
            onClick={() => onCategorySelect(category.id)}
            sx={{
              borderLeft: 3,
              py: 2,
              borderColor: selectedCategory === category.id ? 'primary.main' : 'transparent',
              '&:hover': {
                borderColor: selectedCategory === category.id ? 'primary.main' : 'primary.light',
                bgcolor: 'action.hover'
              },
              transition: 'all 0.2s',
              position: 'relative'
            }}
          >
            <ListItemText
              primary={
                <Typography variant="subtitle1">
                  {category.name}
                </Typography>
              }
              secondary={
                <Box component="span" sx={{ typography: 'body2', color: 'text.secondary' }}>
                  {category.events.length} events
                </Box>
              }
            />
          </ListItemButton>
        ))}
      </List>
    </Paper>
  );
};